import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { ApiCreateEmailResponse } from './types';

type CreateArtistEmailProps = {
  artistId: string;
  domain: string;
};

export const createArtistEmail = async ({ artistId, domain }: CreateArtistEmailProps) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!domain) throw Error('Domain is required');

  const url = `/web/studio/artists/${artistId}/emails/domains`;

  const response = await api.executePostRequest<ObjectResponse<ApiCreateEmailResponse>>(url, {
    domain,
  });

  return response.data;
};
